// extracted by mini-css-extract-plugin
export default {"grid":"OL8o3","wrapperMedium":"pMgpo","wrapperBig":"zievH"};